import { makeStyles } from "@material-ui/core";
 
const useTableStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
    tr: {
        // minWidth: 650,
        backgroundColor: '#fff !important',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#eee !important',
        }
    },
    ppr: {
        margin: '2rem',
        padding: '2rem',
        maxWidth: 'calc(100% - 4rem)'
    },
    tblTitle: {
        marginBottom: '1.5rem',
        color: 'blue',
        fontSize: '1.7rem',
        borderBottom: '1px solid',
    },
    prodImg: {
        height: '3rem',
        maxWidth: '3rem',
        '&:hover': {
            transform: 'scale(4)',
            transition: 'all 1s',
        }
    },
    selectable: {
        '&:hover': {
            transform: 'scale(1.1)',
            transition: 'all 0.5s',
            fontWeight: 700,
        },
        cursor: 'pointer',

    }
    // tblSubTtl: {
    //     fontSize: '1.3rem',
    //     color: '#515194 !important',
    // }
});

export default  useTableStyles